import { debounce } from 'utility/helpers'
import { message } from 'utility/message'
import { formatNumber } from 'utility/helpers'
import { setPositionDuringFormatting } from 'utility/formatCurrency'

const SimplePrivateSavingsCalculator = {
  el: {
    root: document.querySelectorAll('.private-savings-calculator-block'),
  },

  init() {
    if (this.el.root) {
      this.el.root.forEach((target) => {
        const el = {
          form: target.querySelector('.private-savings-calculator-block__inputs-container') as HTMLFormElement,
          button: target.querySelector('.private-savings-calculator-block__button') as HTMLButtonElement,
          inputs: target.querySelectorAll('.input-group__input') as NodeListOf<HTMLInputElement>,
          toggle: target.querySelector('.input-group__wrap--toggle'),
          recaptchaError: target.querySelector('.recaptcha-error'),
          message: target.querySelector('.form__message') as HTMLDivElement,
          results: target.querySelector('.private-savings-calculator-block__results'),
          salaryBeforeTax: target.querySelector('#SalaryBeforeTax') as HTMLInputElement,
        }

        el.form.addEventListener('submit', (e) => {
          e.preventDefault()
          el.salaryBeforeTax.value = formatNumber(el.salaryBeforeTax.value)
          message.reset(el.message)
          this.submit(el, el.form)
        })

        if (el.inputs) {
          el.inputs.forEach((input) => {
            input.addEventListener('keyup', () => {
              setPositionDuringFormatting(input.value, input, input.selectionStart)

              if (input.value.length >= 2) {
                this.debounceInput(el, el.form)
              }
            })
          })
        }

        if (el.toggle) {
          const toggles = el.toggle.querySelectorAll('input')
          if (toggles.length > 0) {
            toggles.forEach((input) => {
              input.addEventListener('click', () => {
                this.submit(el, el.form)
              })
            })
          }
        }

        if (el.button) {
          el.button.click()
        }
      })
    }
  },

  submit: async (el, form) => {
    const action = form.getAttribute('action')
    const formMethod = form.getAttribute('method')
    const formData = new FormData(el.form)

    await fetch(action, {
      method: formMethod,
      body: formData,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          el.results.classList.remove('hide')
          SimplePrivateSavingsCalculator.renderResults(el, response.data)
        } else {
          el.results.classList.add('hide')
          message.show(el.message, response.message)
        }
      })
      .catch((ex) => {
        console.error('Server error: ', ex)
      })
  },

  renderResults: (el, response) => {
    const yourPart = el.results.querySelector('#js-pscr-yourPart')
    const monthlySavings = el.results.querySelector('#js-pscr-monthlySavings')
    const decreaseInDisposableIncome = el.results.querySelector('#js-pscr-decreaseInDisposableIncome')
    const totalCredit = el.results.querySelector('#js-pscr-totalCredit')
    const returnNum = el.results.querySelector('#js-pscr-return')
    const perMonthFor10Years = el.results.querySelector('#js-pscr-perMonthFor10Years')

    yourPart.innerHTML = formatNumber(response.personalContributionPerMonth)
    monthlySavings.innerHTML = formatNumber(response.totalContributionPerMonth)
    decreaseInDisposableIncome.innerHTML = formatNumber(response.changeInTakeHomePay)
    totalCredit.innerHTML = formatNumber(response.personalPensionTotalSavings)
    returnNum.innerHTML = formatNumber(response.personalPensionTotalReturn)
    perMonthFor10Years.innerHTML = formatNumber(response.personalPensionWithdrawalPerMonth)
  },

  debounceInput: (el, form) => {
    debounce(SimplePrivateSavingsCalculator.submit(el, form), 500)
  },
}

export default SimplePrivateSavingsCalculator
